module.exports = __webpack_public_path__ + "images/emoji/mask.d0433016bd9d6974ce72.png";